<div class="app">
  <header>
    <nav class="navbar navbar-expand-lg fixed-top navbar-light bg-light">
      <div class="container-fluid">
        <a class="navbar-brand" href="dashboard">
          <img src="./assets/applogo.png" class="app-logo" />
          <span class="app-title font-bold">
            PrimeCommunication
          </span>
        </a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavDropdown"
          aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse justify-content-end mr-auto" id="navbarNavDropdown">
          <ul class="navbar-nav">
            <!-- Dropdown - TEMP HIDE MANAGE PHARMACY -->
            <li class="nav-item dropdown d-none">
              <a class="nav-link dropdown-toggle" href="" id="navbardrop" data-toggle="dropdown">
                Manage Pharmacy <i class="far fa-angle-down"></i>
              </a>
              <div class="dropdown-menu">
                <a class="dropdown-item" href="#">Add Pharmacy</a>
              </div>
            </li>

            <!-- Dropdown -->
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="" id="navbardrop" data-toggle="dropdown">
                Azure Admin <i class="far fa-angle-down"></i>
              </a>
              <div class="dropdown-menu">
                <a class="dropdown-item" href="azureaccounts">Manage Accounts</a>
                <a class="dropdown-item" href="namespaces">Manage Namespaces</a>
                <a class="dropdown-item" href="endpoints">Manage Endpoints</a>
              </div>
            </li>

            <!-- Dropdown -->
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="" id="navbardrop" data-toggle="dropdown">

                <img class="nav-img" src="./assets/user.svg" />
                <span class="user-nav">{{userDisplayName}}</span>
                <!-- <i class="fas fa-user user-nav-icon"></i>--> <i style="color:#929292;margin-left:5px"
                  class="far fa-angle-down"></i>
              </a>
              <div class="dropdown-menu">
                <a class="dropdown-item" href="#">My Account</a>
                <a class="dropdown-item" (click)="logout()" href="#">Logout</a>
              </div>
            </li>



          </ul>
        </div>
      </div>
    </nav>
  </header>

  <div *ngIf="isShowSuccess" class="fixed-success">
    You have logged in successfully!
  </div>

</div>
